'use strict';

require('../less/common.less');

import $ from 'jquery';

// This allows angular to find jQuery on the window
window.$ = $;
window.jQuery = $;

import angular from 'angular';
import uiRouter from '@uirouter/angularjs';

import videogular from 'videogular';
import videogularControlls from 'videogular-controls';
import videogularBuffering from 'videogular-buffering';
import videogularOverlayPlay from 'videogular-overlay-play';
import videogularThemesDefault from 'videogular-themes-default';

import angularUtilsPagination from 'angular-utils-pagination';

import infiniteScroll from 'ng-infinite-scroll';

import {core} from 'site_core';

// Our Modules
import appRoutes from './app.routes';
import appRun from './app.run';

'ngInject';
var app = angular.module('site', [
  angularUtilsPagination,
  uiRouter,
  core.components,
  core.features,
  core.factories,
  core.filters,
  videogular,
  videogularControlls,
  videogularBuffering,
  videogularOverlayPlay,
  infiniteScroll,
]);

app.config(appRoutes);
app.run(appRun);

app.constant('BASE_URLS', {API: API_URL, CONTENT: CONTENT_URL});

app.constant('siteConst', {
	id: 14,
  urlShort: 'CanedSchoolGirls.com',
  urlLong: 'http://www.CanedSchoolGirls.com',
  urlMed: 'www.CanedSchoolGirls.com',
  name: 'Caned School Girls',
  tagline: '',
  footerTagline: 'We have collected the very best SchoolGirl Caning Videos & Photos from around the Net and are now pleased to offer them here for you to download & enjoy! Fully remastered using the latest enhancement techniques giving superb movie play back quality even on Classic Schoolgirl Caning movie productions!',
  logoLarge: 'images/logo.png',
  logoSmall: 'images/logo_small.png',
  twoTwoFiveSevenAddress: '5400 W. 64th Ave Arvada, CO 80007',
  webmasterEmail: 'webmaster@xerotics.com',
  metaDescription: 'School girl caning video downloads naughty girls caned hard on the bare bottom with knickers down',
  tour: {
    updates: 12,
    comingSoon: 3,
    models: 24
  },
  advert: {
    tour: [
      'Authentic Bare Bottom Schoolgirl Canings',
      'Exclusive Caning Videos and Caning Pictures',
      'Full Updates Twice a Week',
      'Unlimited Streaming and Downloads',
      'HD/SD Mobile and Tablet Ready'
    ],
    trailer: [
      'Authentic Schoolgirl Caning',
      'Exclusive Caning Videos',
      'Full Updates Twice a Week',
      'Unlimited Streaming and Downloads',
      'HD/SD Mobile and Tablet Ready',
      'Classic English Caning',
      'Domestic Discipline Caning',
      'Schoolgirl Caning and Strappings',
      'Marked Ass Caning Photos'
    ]
  }
});



// WEBPACK FOOTER //
// ./src/app/app.js